import React, { useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Card, Image, Table, Button } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import CustomerStore from "../../../app/stores/customerStore";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

interface DetailParams {
  id: string;
}

const CustomerDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const customerStore = useContext(CustomerStore);
  const { customer, loadCustomer, loadingInitial } = customerStore;

  useEffect(() => {
    loadCustomer(match.params.id);
  }, [loadCustomer, match.params.id]);

  if (loadingInitial || !customer)
    return <LoadingComponent content="Loading Customer ..." />;

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>{customer.name}</Card.Header>
        <Table definition>
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>Name</Table.Cell>
              <Table.Cell> {customer!.name} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>ABN</Table.Cell>
              <Table.Cell> {customer!.abn} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Address</Table.Cell>
              <Table.Cell> {customer!.address} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Contact Name</Table.Cell>
              <Table.Cell> {customer!.contactName} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Email</Table.Cell>
              <Table.Cell> {customer!.email} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Phone</Table.Cell>
              <Table.Cell> {customer!.phone} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Remark</Table.Cell>
              <Table.Cell> {customer!.remark} </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card.Content>
      <Card.Content extra>
        <Button.Group widths={2}>
          <Button
            as={Link}
            to={`/dailymanagement/customer-edit/${customer.id}`}
            basic
            color="blue"
            content="Edit"
          />
          <Button
            onClick={() => history.goBack()}
            basic
            color="grey"
            content="Cancel"
          />
        </Button.Group>
      </Card.Content>
    </Card>
  );
};

export default observer(CustomerDetails);
